export function getDefaultFilters() {
  return {
    filterData: {
      page: 1,
      filterOptions: {
        startDate: new Date(),
        endDate: null
      },
      sortingOptions: {}
    }
  }
}


// WEBPACK FOOTER //
// ./src/containers/Layouts/Admin/DailyReport/helpers.js